module.exports = __webpack_public_path__ + "static/media/meinVisual_noum.0666d7ec.svg";